import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { VnaClientListComponent } from './management/components/vna-client-list/vna-client-list.component';
import { VnaClientService} from './management/service/vna-client.service';
import { EditVnaClientModalComponent } from './management/modals/edit-vna-client-modal/edit-vna-client-modal.component';

@NgModule({
    imports: [
      CommonModule,
      SharedModule
  ],
    entryComponents:[
        EditVnaClientModalComponent
    ],
    declarations: [
      VnaClientListComponent,
      EditVnaClientModalComponent
  ],

    providers:[
        VnaClientService
    ]
})
export class ClientModule { }



// WEBPACK FOOTER //
// /var/www/backend/src/app/client/client.module.ts